<template>
  <model-table
    :collection="kitchenDisplays"
    :orderable="true"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { field: 'kitchenDisplayType', component: 'model' },
      { name: 'locations', field: (kitchenDisplay) => $_.map(kitchenDisplay.locations.data, 'displayName'), component: 'chips', limitValues: 4 },
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
    :has-library="!currentCircuit.isLibrary"
    :library-collection="kitchenDisplayLibrary"
    :library-columns="[
      { field: 'name' },
      { field: 'kitchenDisplayType', component: 'model' },
      { name: 'locations', field: (kitchenDisplay) => $_.map(kitchenDisplay.locations.data, 'displayName'), component: 'chips', limitValues: 2 }
    ]"
    :link-filter="libraryFilterFunction"
  >
    <kitchen-display-form />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import KitchenDisplayForm from 'src/modules/admin/kitchen-display/KitchenDisplayForm'

export default {
  name: 'KitchenDisplayTable',
  components: {
    ModelTable,
    KitchenDisplayForm
  },
  configuration: ['currentCircuit'],
  models: {
    kitchenDisplays: {
      kitchenDisplayType: {
        fields: ['id', 'name']
      },
      locations: {
        fields: ['id', 'name'],
        locationGroup: {
          fields: ['id', 'name']
        }
      },
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    kitchenDisplayLibrary: {
      libraryChildSiteIds: true,
      kitchenDisplayType: {
        fields: ['id', 'name']
      },
      locations: {
        fields: ['id', 'name'],
        locationGroup: {
          fields: ['id', 'name']
        }
      },
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
